const serviceTerms = [
    { 
        id: "overview", 
        title: "1. Overview", 
        content: [
            "This section provides a high-level summary of the terms governing your use of Altours' travel services.",
            "By accessing our website or booking services through Altours, you agree to comply with all provisions outlined in these Terms & Conditions."
        ]
    },
    { 
        id: "acceptable-use", 
        title: "2. Acceptable Use", 
        content: [
            "Our platform must be used responsibly and ethically.",
            "Activities such as unauthorized access, fraudulent bookings, misuse of travel packages, or engaging in unlawful behavior are strictly prohibited."
        ]
    },
    { 
        id: "subscription", 
        title: "3. Bookings & Payments", 
        content: [
            "All services are subject to availability and require confirmed bookings through our platform.",
            "Payments for bookings, tours, or packages must be made in accordance with the provided payment terms.",
            "Failure to make timely payments may result in cancellation of bookings."
        ]
    },
    { 
        id: "user-obligations", 
        title: "4. User Obligations", 
        content: [
            "Users must ensure that the information provided during bookings is accurate and up-to-date.",
            "Users are responsible for safeguarding their account credentials and booking details.",
            "Any unauthorized or suspicious activity should be reported immediately to Altours support."
        ]
    },
    { 
        id: "limitation-liability", 
        title: "5. Limitation of Liability", 
        content: [
            "Altours shall not be held liable for indirect or incidental damages arising from the use or inability to use our platform and services.",
            "This includes disruptions caused by third-party services, natural disasters, or unforeseen travel restrictions."
        ]
    },
    { 
        id: "termination", 
        title: "6. Termination", 
        content: [
            "We reserve the right to terminate or suspend your access to our services for violations of these Terms & Conditions.",
            "Such terminations may occur with or without prior notice, depending on the severity of the breach."
        ]
    },
    { 
        id: "intellectual-property", 
        title: "7. Intellectual Property", 
        content: [
            "All content, design elements, and technology associated with the Altours platform are the intellectual property of Altours Travel Agency.",
            "Users are granted a limited license to use the platform for personal or business-related travel planning in accordance with these terms."
        ]
    },
    { 
        id: "governing-law", 
        title: "8. Governing Law", 
        content: [
            "These Terms & Conditions are governed by the laws of [Your Jurisdiction].",
            "Any disputes shall be resolved in the courts of [City/Region]."
        ]
    },
    { 
        id: "contact-info", 
        title: "9. Contact Information", 
        content: [
            "For any inquiries regarding these Terms & Conditions or our services, please reach out to us via:",
            "Email: support@altours.com",
            "Phone: +[Your Phone Number]"
        ]
    }
];

export default serviceTerms;